<template>
  <div class="done-order">
    <div class="done-order__check"><i class="icon-check"></i></div>
    <div class="done-order__title">{{ t('message["Your order is successfully."]', 'Your order is successfully.') }}
    </div>
    <div class="done-order__info">
      {{ t('message["Please, wait ours delivery guy"]', 'Please, wait ours delivery guy') }} </div>
    <button @click="redirect" class="done-order__submit">
      {{ t('message["Continue Shopping"]', 'Continue Shopping') }}
    </button>
  </div>
</template>

<script>
import translate from '../../mixins/translate'

export default {
  mixins: [translate],
  methods: {
    redirect() {
      this.$emit('submit');
      this.$router.push({ name: 'home' })
    }
  }
}
</script>